module.exports = __webpack_public_path__ + "img/1a5381e28ae509a9c1c2494feb4bfd52.png";